import { render, staticRenderFns } from "./singleProduct.vue?vue&type=template&id=d7f23c00&scoped=true&"
import script from "./singleProduct.vue?vue&type=script&lang=js&"
export * from "./singleProduct.vue?vue&type=script&lang=js&"
import style0 from "./singleProduct.vue?vue&type=style&index=0&id=d7f23c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f23c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VApp,VBtn,VCard,VCardText,VCardTitle,VDataTable,VDivider,VFlex,VLayout,VList,VListTile,VListTileContent,VListTileSubTitle,VListTileTitle,VSnackbar,VSpacer,VToolbar,VToolbarTitle})
